



import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  username: string
  path: string
  className?: string;
  style?: React.CSSProperties | string
}

interface State {
  
}

export default class WxOpenLaunchWeapp extends React.Component<any, State> {

 	public state: State = {
    
  };


	public render() {
    	const { className, username, style, path } = this.props;
    	return (
        // @ts-ignore
        <wx-open-launch-weapp id="launch-btn" style={style} username={username} path={path}><script type="text/wxtag-template">{this.props.children}</script></wx-open-launch-weapp>
    	)
  }
}
